import BecoDosJoses from '../assets/beco_dos_joses.jpeg';
import IgrejaMatrizDeSaoJose from '../assets/igreja-matriz-de-sao-jose.jpg';
import MonumentoAoPoeta from '../assets/monumento-ao-poeta.jpg';
import PacoMunicipal from '../assets/paco-municipal.jpg'
import BecoDeLaura from '../assets/beco-de-laura.jpg';
import IgrejaMatrizSaoJudasTadeu from '../assets/igreja-matriz-sao-judas-tadeu.jpg';
import PorDoSolDoMonte from '../assets/por-do-sol-do-monte.jpg';
import CasaLyra from '../assets/casa-lyra.jpg';
import Santuario from '../assets/santuario_nossa_senhora.jpg';

export const tourismData = [
  {
    id: 1,
    nome: 'Beco dos Josés',
    descricao: `
**Lista dos Josés - Beco dos Josés**

1. José Correia (Nozinho)  
2. Zé Baixinho  
3. Zé Cajá  
4. Zé Clementino  
5. Zé de Juvino  
6. Zé Duda  
7. Zé Leão  
8. Zé Paulo  
9. Zé Queiroz  
10. Zé Rocha  
11. Zé Roque  
12. Zé Salú  
13. Zezé da Sorveteria

---

**O Beco dos Josés: um lugar, muitas histórias e memórias**.

O Beco foi palco de encontros cotidianos, de comércios que alimentaram a Cidade, de mãos que serviram cafés, cortaram cabelos, venderam sonhos e escutaram histórias.  
Nesta homenagem, reunimos as trajetórias de pessoas que fizeram do Beco um símbolo vivo da vida em partilha e comunidade. São figuras como Zé Baixinho, Zé Cajá, Zé Duda, Zé Rocha, Zé Queiroz, Zé Salú, Dona Zezé e tantos outros nomes que, com seus ofícios, personalidades e famílias, construíram o tecido invisível que une vizinhança, memória e identidade.  
Ao narrar essas biografias, celebramos vidas que marcaram a história de São José do Egito, não por estarem nos livros escolares, mas por estarem nas lembranças de quem passou pelo Beco, pelas mãos de quem ali viveu, comprou, trabalhou ou simplesmente ficou para uma boa prosa.  
O Beco dos Josés é, sobretudo, uma homenagem à força da memória afetiva. Um convite para que nunca esqueçamos que toda cidade é feita, antes de tudo, por sua gente.

---

**Maria José dos Santos (D. Zezé de Chico Silva ou Zezé da Sorveteria)** nasceu em 1933, em São José do Egito. Casou-se com Francisco de Aquino dos Santos, conhecido como Chico Silva, com quem teve oito filhos. Ao lado do esposo, foi proprietária de um restaurante e uma sorveteria no Beco, além de manter uma padaria e o antigo Cine Teatro São José. Figura importante da história comercial e afetiva da cidade, faleceu em 13 de agosto de 2014, aos 81 anos de idade.

![Dona Zezé](/images/dona-zeze.jpg)

**José Amaro da Rocha (Zé Duda)** nasceu em 22 de abril de 1934, em São José do Egito. Casado com Gercina Maria de Assis, com teve nove filhos. Foi proprietário de um bar no Beco, espaço onde se tornou figura bastante conhecida. Faleceu em 7 de agosto de 1993, aos 59 anos de idade, deixando nove filhos.

![José Duda](/images/jose-duda.jpg)

**José Correia (Nozinho)** nasceu em 18 de agosto de 1927, na cidade de Brejinho/PE. Ainda muito cedo, veio morar em São José do Egito, com sua esposa Juvita Moreira, com quem teve seis filhos. Nozinho, como ficou conhecido, trabalhou como agricultor e barbeiro no salão do senhor José Salu. Faleceu em 23 de março de 1983, aos 56 anos de idade.

![José Correia](/images/jose-correia.jpg)

**José Clementino de Siqueira (Zé Clementino)** nasceu em 23 de abril de 1919, em Itapetim/PE, cidade onde residiu até 1950, quando se mudou para São José do Egito ao lado da esposa Luzia Lúcia de Siqueira, com teve onze filhos. O comerciante foi proprietário de uma bodega e anos depois abriu uma serraria. Faleceu em 29 de novembro de 1996.

![José Clementino](/images/jose-clementino.jpg)

**José Hibraim Lira (Zé Roque)** nasceu em 1 de janeiro de 1923, em São José do Egito/PE. Foi casado com Laudelina Souza, com quem teve cinco filhos. Inicialmente, atuou como alfaiate no Beco e, posteriormente, tornou-se dono de uma bodega, estabelecendo ali sua trajetória de trabalho. Faleceu em 2003, aos 80 anos de idade.

![José Roque](/images/jose-roque.jpg)

**José Justino Filho (Zé Baixinho)** nasceu em 1930, na cidade de Teixeira/PB. Tempos depois, veio residir em São José do Egito. Ao lado de sua companheira Olívia Lucena da Nóbrega, tiveram 23 filhos. Foi dono de um restaurante no Beco e também atuou como bicheiro e garimpeiro, sendo uma figura conhecida pela sua multiplicidade de atividades. Faleceu em 11 de julho de 1983, aos 53 anos de idade.

![Zé Baixinho](/images/jose-justino.jpg)

**José Juvino de Oliveira (Zé de Juvino)**, nasceu em 13 de setembro de 1925 em São José do Egito/PE. Foi casado com Rita Cordeiro Inô de Oliveira, com teve seis filhos. Foi agricultor, comerciante e também exerceu o cargo de vice prefeito da sua cidade natal. Faleceu em 13 de setembro de 2022.

![José Juvino](/images/jose-juvino.jpg)

**José Leão de Oliveira (Zé Leão)** nasceu em 7 de julho de 1934, em São José do Egito. Foi casado com Dirça Piancó Oliveira, com quem teve sete filhos. Trabalhou como agricultor até 1961, quando abriu um restaurante e passou a se dedicar ao novo estabelecimento. Faleceu em 27 de março de 1999, aos 64 anos.

![José Leão](/images/jose-leao.jpg)

**José Medeiros Queiroz (Zé Queiroz)** nasceu em 30 de setembro de 1914, em São José do Egito. Casado com Severina Maria Vieira Valadares Queiroz (Nininha), com quem teve dois filhos. Foi proprietário da Drogaria São José e da Fazenda Leopoldina, além de ter exercido dois mandatos como vereador. Faleceu em 8 de janeiro de 2011, em Recife, aos 96 anos.

![José Queiroz](/images/jose-queiroz.jpg)

**José Pedro da Silva (Zé Cajá)** nasceu em 18 de agosto de 1917, em São José do Egito. Ao longo da vida, exerceu múltiplas atividades: foi pedreiro, barbeiro e proprietário de um restaurante no Beco. Pai de seis filhos, faleceu em 17 de abril de 2011, aos 93 anos de idade.

![José Cajá](/images/jose-caja.jpg)

**José Rocha Sobrinho (Zé Rocha Barbeiro)** nasceu em 1 de janeiro de 1934, em São José do Egito, Pernambuco. Trabalhou como barbeiro e mantinha sua barbearia no Beco, sendo figura bastante conhecida na comunidade. Faleceu em 25 de março de 2015, aos 81 anos, deixando cinco filhos.

![José Rocha](/images/jose-rocha.jpg)

**José Salustiano de Souza (Zé Salú)** nasceu em 1902, na cidade de Belo Jardim/PE. Foi casado com Tereza Maria de Souza, com quem teve dez filhos. Ao longo da vida, trabalhou como agricultor, criador de gado e barbeiro, tendo sua barbearia no Beco. Zé Salú faleceu em 1999, aos 97 anos de idade.

![José Salú](/images/jose-salu.jpg)

**José Sebastião de Menezes (Zé Paulo)** nasceu em meados de 1899 em São José do Egito/PE. Foi agricultor, mas ao se mudar para São José do Egito, também trabalhou como “chapeado” e banqueiro de jogo do bicho. Era figura popular por suas tiradas rápidas e engraçadas. Pai de quatro filhos, faleceu em 19 de junho de 1977, aos 78 anos de idade.

![José Paulo](/images/jose-paulo.jpg)

---

Combino com meu passado  
Reencontro precioso  
E me vejo arremessado  
Para o beco mais saudoso  
Dos "Josés" de São José  
Dos "Josés" fontes da vida  
E sinto que cada Zé  
Sente emoção incontida:  
Zé Duda com Zé Leão  
Vendem cachaça pitú  
E Zé Paulo do milhão  
Empresta de Zé Salú  
José Correia, Nozinho  
Barbeia Zé de Juvino  
E a sopa, seu Zé Baixinho  
Serve pra Zé Clementino  
Zé Rocha com linda voz  
Canta cortando cabelo  
Do cliente Zé Queiroz  
Que aprova o corte modelo  
E Zé Roque faz costura  
Zé Cajá ferve o café  
Dona Zezé põe doçura  
No sorvete picolé.

Arlindo Lopes
`,
    endereco: 'Rua 1º de Janeiro, 08, Centro',
    enderecoMaps: 'Beco dos Josés, Rua 1º de Janeiro, 08, Centro, São José do Egito - PE, 56700-000',
    maps: 'https://maps.app.goo.gl/L3QZhR6RPwsJ6jyo8',
    url: 'beco-dos-joses',
    imagem: BecoDosJoses,
  },
  {
    id: 2,
    nome: 'Beco de Laura',
    descricao: `O Beco de Laura recebeu esse nome em homenagem a uma antiga moradora que tinha um restaurante/lanchonete no local, onde produzia doces e, principalmente, se destacava pela paciência ao atender quem pedia um copo de água gelada, já que não possuía geladeira. Hoje, o Beco de Laura é um dos pontos turísticos mais visitados da cidade. Decorado com poesias nas paredes e cores vibrantes, oferece um ambiente tranquilo, ideal para quem quer relaxar e aproveitar a poesia local.`,
    endereco: 'Beco de Laura, Centro',
    enderecoMaps: 'Beco de Laura, Centro - São José do Egito, PE, 56700-000',
    maps: 'https://maps.app.goo.gl/PKae6JcCwsJJiuYV6',
    url: 'beco-de-laura',
    imagem: BecoDeLaura
  },
  {
    id: 3,
    nome: 'Paço Municipal',
    descricao: `Localizado entre as Ruas Presidente João Pessoa e Joaquim Nabuco, o Paço Municipal é um dos edifícios mais imponentes de São José do Egito. Já foi palco de grandes eventos da cidade e, além de ser a sede da Prefeitura, serviu como Câmara de Vereadores e abrigou o Memorial da Cultura Popular. Em breve, será inaugurado como o Museu da Poesia.`,
    endereco: 'R. Pres. João Pessoa',
    enderecoMaps: 'R. Pres. João Pessoa - São José do Egito, PE, 56700-000',
    maps: 'https://maps.app.goo.gl/Nyc3QefVZ856VM9S6',
    url: 'paco-municipal',
    imagem: PacoMunicipal
  },
  {
    id: 4,
    nome: 'Escadaria do Bairro Antônio Marinho',
    descricao: `A escadaria do Bairro Antônio Marinho é um dos pontos turísticos mais famosos de São José do Egito. Além de ser um ótimo local para fotos, o local também revela um pouco da poesia da cidade e permite que os visitantes apreciem a beleza do santuário dedicado à Nossa Senhora do Carmo.`,
    endereco: 'R. Cícero B Siqueira, 30 - Ni',
    enderecoMaps: 'Escadaria da poesia, R. Cícero B Siqueira, 30 - Ni, São José do Egito - PE, 56700-000',
    maps: 'https://maps.app.goo.gl/oVQ5ySUBAWyuZqJF8',
    url: 'escadaria-do-bairro-antonio-marinho',
    imagem: ''
  },
  {
    id: 5,
    nome: 'Igreja Matriz de São José',
    descricao: `A história de São José do Egito está diretamente ligada à sua primeira igreja. Hoje, a Igreja Matriz de São José é um dos principais cartões postais da cidade e continua desempenhando um papel central no município.`,
    endereco: 'R. Cel. Inácio Mariano Valadares',
    enderecoMaps: 'Igreja Matriz São José, R. Cel. Inácio Mariano Valadares - São José do Egito, PE, 56700-000',
    maps: 'https://maps.app.goo.gl/Du1uee4LoAiSnDTE9',
    url: 'igreja-matriz-de-sao-jose',
    imagem: IgrejaMatrizDeSaoJose
  },
  {
    id: 6,
    nome: 'Santuário Nossa Senhora das Graças',
    descricao: `Santuário Nossa Senhora das Graças é famosa por seu formato peculiar que lembra uma cuscuzeira. Originalmente construída na década de 1950, a caixa d’água foi feita para abastecer a cidade, tendo um importante valor histórico para toda população.`,
    endereco: 'R. Alto da Boa Vista, 73',
    enderecoMaps: 'Santuário de Nossa Senhora das Graças, R. Alto da Boa Vista, 73 - São José do Egito, PE, 56700-000',
    maps: 'https://maps.app.goo.gl/mjpK8er3jd3xSnfcA',
    url: 'santuario-nossa-senhora-das-gracas',
    imagem: Santuario
  },
  {
    id: 7,
    nome: 'Igreja Matriz São Judas Tadeu',
    descricao: `A paróquia foi oficialmente criada em 28 de outubro de 2000, por decreto de Dom Francisco Austregésilo de Mesquita Filho, então bispo da Diocese de Afogados da Ingazeira. O novo território paroquial foi desmembrado da tradicional Paróquia de São José, abrangendo diversas comunidades urbanas e rurais do município. Desde então, a devoção a São Judas Tadeu, padroeiro das causas impossíveis, se consolidou como uma das mais fortes expressões de fé popular da cidade.

O templo, de arquitetura moderna em formato de cruz, é um dos mais belos exemplos da estética religiosa contemporânea no Sertão do Pajeú. Os vitrôs coloridos, dispostos de forma estratégica, permitem que a luz natural penetre o interior do santuário, criando um espetáculo de cores e espiritualidade que encanta moradores e turistas.

A torre sineira, ou campanário, guarda um simbolismo especial: seus sinos foram instalados para marcar os jubileus da comunidade. O primeiro, em celebração aos 10 anos de fundação, e o segundo, por ocasião da abertura do  jubileu de 25 anos,  em 2024. Cada toque dos sinos é um convite à oração e à memória viva da caminhada paroquial.

Além de seu valor religioso, a Paróquia São Judas Tadeu é hoje um importante ponto de visitação turística. Seu espaço acolhedor e sua vista panorâmica da cidade fazem do local um cenário perfeito para fotos, momentos de contemplação e encontros culturais.`,
    endereco: 'Rua Tereza de Jesus Campos, 92',
    enderecoMaps: 'Igreja Matriz São Judas Tadeu, 116, Rua Tereza de Jesus Campos, 92, São José do Egito - PE, 56700-000',
    maps: 'https://maps.app.goo.gl/qdSswJrsRro2Yoe19',
    url: 'igreja-matriz-sao-judas-tadeu',
    imagem: IgrejaMatrizSaoJudasTadeu
  },
  {
    id: 8,
    nome: 'Pôr-do-Sol do Monte',
    descricao: `A Capela de Nossa Senhora dos Remédios, também conhecida como Capela do Monte, está situada no principal cartão postal de São José do Egito. No topo do Monte, é possível ver a cidade inteira e outros pontos vizinhos, como o Pico do Jabre, o ponto mais alto do estado da Paraíba. Todo 15 de agosto, a pequena igreja recebe a Missa do Monte, uma tradição que atrai fiéis de diversas localidades. Além de orar, os moradores e visitantes frequentam o Monte para apreciar a paisagem, praticar atividades físicas e, claro, para o famoso pôr do sol, que se tornou uma parada obrigatória para quem visita a cidade.`,
    endereco: 'Serra Do Monte - Igreja Nossa Senhora Dos Remedios',
    enderecoMaps: 'Serra Do Monte - Igreja Nossa Senhora Dos Remedios - São José do Egito, PE, 56700-000',
    maps: 'https://maps.app.goo.gl/LooLTGa7XHhRsKtDA',
    url: 'por-do-sol-do-monte',
    imagem: PorDoSolDoMonte
  },
  {
    id: 9,
    nome: 'Portal da Entrada de São José do Egito',
    descricao: `
São José do Egito, uma cidade onde a poesia faz parte da sua essência, está localizada a 404 km de Recife. Para chegar lá, é possível acessar via PE-275, BR-110 ou BR-232 (passando por Sertânia). A agricultura é uma das principais atividades econômicas da cidade, com grande parte de seu território sendo rural. Além da área central, São José do Egito é composta pelos distritos de Bonfim e Riacho do Melo, além de povoados como Batatas, Curralinho, Mundo Novo, Espírito Santo, São Sebastião do Aguiar e Juazerinho. A cidade faz fronteira com Brejinho e Itapetim ao norte, Tuparetama e Ingazeira ao sul, Tabira e Santa Terezinha a oeste, e o estado da Paraíba a leste.

**Curiosidade:**

O Portal da cidade, símbolo da poesia e da cantoria local, exibe a imagem de um braço de viola como homenagem. Mesmo após algumas mudanças estruturais, esse elemento continua marcando a entrada da cidade, atraindo a curiosidade de todos que chegam.
    `,
    endereco: 'Entrada da cidade, sentido Recife',
    enderecoMaps: '',
    maps: '',
    url: 'portal-da-entrada-de-sao-jose-do-egito',
    imagem: ''
  },
  {
    id: 10,
    nome: 'Instituto Lourival Batista - Louro',
    descricao: `Lourival Batista é um dos grandes nomes da poesia popular e um dos maiores poetas do Sertão. Natural de São José do Egito, seus versos retratam a pureza e a beleza da vida sertaneja, traduzindo a saudade e os valores do povo. A biblioteca construída por sua família é um dos pontos culturais mais importantes da cidade e continua atraindo visitantes interessados na cultura local.`,
    endereco: 'R. Domingos Siqueira, 119 - Centro',
    enderecoMaps: 'Instituto Lourival Batista, R. Domingos Siqueira, 119 - Centro, São José do Egito - PE, 56700-000',
    maps: 'https://maps.app.goo.gl/FSJffPri3TrrDvsz9',
    url: 'instituto-lourival-batista',
    imagem: ''
  },
  {
    id: 11,
    nome: 'Monumento ao Poeta',
    descricao: `O Monumento ao Poeta é uma homenagem à poesia local e está localizado na praça da cidade. O monumento celebra o trabalho de Wilson Cardoso Dias, o "homem das poesias", conhecido por suas belas poesias que falam da vida sertaneja, do amor e da saudade.`,
    endereco: 'Rua Governador Walfredo Siqueira, 38',
    enderecoMaps: 'Monumento aos poetas, Rua Governador Walfredo Siqueira, 38 - São José do Egito, PE, 56700-000',
    maps: 'https://maps.app.goo.gl/WCRaagmr6ufVLP9T9',
    url: 'monumento-ao-poeta',
    imagem: MonumentoAoPoeta
  },
  {
    id: 12,
    nome: 'Casa Lyra',
    descricao: `Fundada em 1915, a Casa Lyra é um dos mais antigos e emblemáticos estabelecimentos comerciais de São José do Egito, no Sertão do Pajeú. Localizada no centro da cidade, a loja começou como um armazém e, com o tempo, tornou-se um tradicional armarinho, conhecido especialmente pela venda da icônica linha de costura Corrente Laranja, muito procurada por costureiras e artesãos da região.

Por décadas, a Casa Lyra foi administrada por Mário Vieira de Lyra, um comerciante respeitado e querido pela população. Após seu falecimento em 1990, a responsabilidade pela loja passou para sua esposa, Maria José Veras Lyra, carinhosamente conhecida como Dona Alila — uma mulher forte, culta e profundamente ligada à vida da cidade.

Antes de assumir a loja, Dona Alila teve uma trajetória marcante na educação, tendo sido diretora da Escola Estadual de Referência Oliveira Lima por 30 anos. Em 1987, ao ser afastada do cargo, passou a dedicar-se integralmente à Casa Lyra, transformando o armarinho em um espaço de convivência, memória e afeto.

Dona Alila cuidou da loja com dedicação até seus últimos dias, mantendo-a aberta todos os dias, como vinha sendo feito há mais de um século. Com o apoio fiel da amiga Lúcia de Souza Silva, ela manteve viva não apenas uma tradição comercial, mas um verdadeiro patrimônio afetivo da cidade.

Com o falecimento de Dona Alila, encerra-se um ciclo pessoal, mas renasce um novo propósito para o espaço: a Casa Lyra reabre agora como Centro de Atendimento ao Turista e Memorial do Povo Egipciense, celebrando seus 110 anos de existência e sua profunda conexão com a história de São José do Egito.

Mais do que um comércio, a Casa Lyra é hoje um lugar de memória, de pertencimento e de homenagem. Um espaço onde o passado é preservado com dignidade e onde a história de um povo se faz presente em cada detalhe.`,
    endereco: 'R. Pres. João Pessoa, 49',
    enderecoMaps: 'Casa Lyra, R. Pres. João Pessoa, 49 - São José do Egito, PE, 56700-000',
    maps: 'https://maps.app.goo.gl/TJwp7m2w9eynV1rY7',
    url: 'casa-lyra',
    imagem: CasaLyra
  },
  {
    id: 13,
    nome: 'Praça Seresteiro João Pequeno',
    descricao: `![João Pequeno](/images/joao-pequeno2.jpg) João Bento de Menezes, mais conhecido como João Pequeno, foi um homem de bom trato, boêmio e seresteiro. Nascido no dia 03 de maio de 1923, em São José do Egito-PE, era filho de Estefânia Augusta Menezes e de Manoel Bento de Menezes. 
	Irmão caçula de uma família numerosa, João Pequeno teve sete irmãos: Aurélio, conhecido como Aurélio do café, Maria Augusta, Genésia, Otacília, Dário, José e Laura do hotel, cujo nome batiza o mais tradicional beco de São José: o beco de Laura. 
	O seresteiro João Pequeno foi casado com Adalcina e tiveram juntos um único filho: José Tadeu. Após o primeiro casamento, conheceu Maria Nely Costa Menezes, com quem sete filhos: Maria Aparecida, Estefânia Augusta, José Marcelo, Teresa Cristina, Hélder, João Bento e Daniele Patrícia. 
	Com os filhos crescidos vieram os netos: Natália, Emanuelle Maria, Maria Clara e João Victor; Rodrigo e Fernando; Caio Graco, Maria Júlia e Maria Clarice; João Guilherme e Júlia Leandro; e os bisnetos: Daniel e Pietra. 
	De fundamental importância para a formação de músicos que o sucederam, João Pequeno é uma referência da cultura egipciense. 
	No dia 16 de outubro de 1993, aos 70 anos, sua voz calou-se e aquietram-se as cordas do violão. Não obstante, as noites de São José do Egito, hoje mais silenciosas, rendem homenagem a um de seus maiores seresteiros. 
  ![João Pequeno](/images/joao-pequeno1.jpg)
  `,
    endereco: '',
    enderecoMaps: '',
    maps: '',
    url: 'praca-seresteiro-joao-pequeno',
    imagem: ''
  },
];